import { render } from "./Application.vue?vue&type=template&id=286ca6a0&scoped=true&lang=pug"
import script from "./Application.vue?vue&type=script&lang=coffee"
export * from "./Application.vue?vue&type=script&lang=coffee"

import "./Application.vue?vue&type=style&index=0&id=286ca6a0&scoped=true&lang=stylus"

import exportComponent from "C:\\OSPanel\\home\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286ca6a0"]])

export default __exports__